import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiInfo, FiLock } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-black/40 backdrop-blur-lg border-t border-purple-500/20 mt-16">
      <div className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="flex items-center justify-center space-x-3 mb-4">
            <SafeIcon icon={FiShield} className="text-2xl text-purple-400" />
            <h3 className="text-xl font-bold text-white">OSINT Identity Verifier</h3>
          </div>
          <div className="flex items-center justify-center space-x-8 mb-6 text-purple-300">
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiLock} className="text-lg" />
              <span className="text-sm">Privacy Protected</span>
            </div>
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiInfo} className="text-lg" />
              <span className="text-sm">Public Data Only</span>
            </div>
          </div>
          <p className="text-purple-300 text-sm max-w-2xl mx-auto">
            This tool analyzes publicly available information to verify identities. No private data is accessed, stored, or compromised. Results are for informational purposes only.
          </p>
          <div className="mt-6 pt-6 border-t border-purple-500/20">
            <p className="text-purple-400 text-xs">
              © 2024 OSINT Identity Verifier. Built for educational and verification purposes.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;